import {state as lifecycle} from 'fragments/lifecycle';
const date = new Date();

export default {
	...lifecycle,
	loading: true,
	report: null,
	reportQuery: {
		startTime: new Date(date.getFullYear(), date.getMonth(), 1, 12)
			.toISOString()
			.split('T')[0],
		endTime: new Date().toISOString().split('T')[0],
	},
};
